const siteInfo = {  siteName:"Démo technique",
                    auteur:"Nicolas Mendoula",
                    anneeCreation:"2020"
                }

export default siteInfo;